import { useNavigate } from "react-router-dom";
import { Autocomplete, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import structure from "./structure";

const options = structure
  .reduce((sections, s) => {
    return [
      ...sections,
      ...s.items.reduce((groups, g) => {
        if (!g.group) {
          return [
            ...groups,
            {
              label: g.name,
              path: `/${s.path}/${g.path}`,
            },
          ];
        }
        return [
          ...groups,
          ...g.group.map((i) => ({
            label: i.name,
            path: `/${s.path}/${g.path}/${i.path}`,
          })),
        ];
      }, []),
    ];
  }, [])
  .sort((a, b) => (a.label < b.label ? -1 : a.label > b.label ? 1 : 0));

const GlobalSearch = () => {
  const navigate = useNavigate();
  return (
    <Autocomplete
      blurOnSelect
      options={options}
      value={null}
      onChange={(e, v) => navigate(v.path)}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Search..."
          InputProps={{
            ...params?.InputProps,
            endAdornment: <SearchIcon />,
          }}
          size="small"
        />
      )}
      sx={{
        width: "20rem",
        ".MuiInputBase-root": {
          borderRadius: "8px",
          pr: "8px !important",
        },
      }}
    />
  );
};

export default GlobalSearch;
